export default class ItemExtraIngredient {
    constructor() {
        this.id = "";
        this.localizedNames = "";
        this.price = undefined;
        this.selected = false;
    }
}
